/* @source catpaw @line_count 87 @branch feature/ywh-ones-89612040*/
<template>
  <BikeDialog
    v-model="config.visible"
    v-bind="config"
    :title="title"
    :showDefaultFooter="false"
    @close="onClose"
  >
    <BikeTable v-bind="bikeTable" :loading="isLoading" />
    <template #footer>
      <mtd-button @click="onClose">关闭</mtd-button>
    </template>
  </BikeDialog>
</template>

<script>
import {
  PLAN_TYPE,
  feeRateColumns,
  feeAccountFeeColumns,
  feeComplianceRateColumns,
  feeAccountFeeKeyNames,
} from '../constant'

export default {
  name: 'FeeDetailDialog',
  props: {
    config: {
      type: Object,
      default: () => ({}),
    },
    data: {
      type: Object,
      default: () => ({}),
    },
    fundsId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      title: '',
      bikeTable: {
        columns: [],
        list: [],
      },
    }
  },

  watch: {
    fundsId: {
      handler(val) {
        if (val) {
          this.title = val === 'accountFee' ? '合作商承担费用汇总' : '绩效考核结果明细'
          this.bikeTable.columns = this.setColumns().map(item => ({
            ...item,
            align: 'right',
          }))
          this.getDetail()
        }
      },
      immediate: true,
    },
  },

  methods: {
    onClose() {
      this.$emit('close')
    },

    setColumns() {
      // 合作商承担费用
      if (this.fundsId === 'accountFee') {
        return feeAccountFeeColumns
      }
      // 合规运营分成方案
      if (this.data.planType === PLAN_TYPE.COMPLIANCE) {
        return feeComplianceRateColumns
      }
      // XYZ/标准/特殊方案
      return feeRateColumns
    },

    getDetail() {
      this.isLoading = true
      const params = {
        id: this.data.id,
        fundsId: this.fundsId,
      }
      this.fetch
        .get('reconcileBill_billFee', { params })
        .then(res => {
          /* @source catpaw @line_count 6 @branch feature/ywh-ones-89612040 */
          const { list } = res.data || {}
          if (this.fundsId === 'accountFee') {
            this.formatAccountFeeList(list)
          } else {
            this.formatRateList(list)
          }
          this.isLoading = false
        })
        .catch(() => {
          this.isLoading = false
        })
    },

    formatAccountFeeList(list) {
      this.bikeTable.list = feeAccountFeeKeyNames.map(item => {
        const listItem = (list || []).find(_ => _.itemId === item.itemId) || {}
        return {
          ...listItem,
          ...item,
        }
      })
    },

    formatRateList(list) {
      const formatData = (list || []).reduce((acc, item) => {
        acc[item.itemId] = item.amount
        return acc
      }, {})

      // 当前账期没有Z考核分成系数（为空或为0），Z扣减系数设为空
      if (!formatData.ratioZ) {
        formatData.zDeductRatio = ''
        formatData.zDeductFee = ''
      }
      // y最终系数（为空或为0），y扣减系数、y扣减金额为空
      if (!formatData.ratioY) {
        formatData.yDeductRatio = ''
        formatData.yDeductFee = ''
      }
      this.bikeTable.list = [formatData]
    },
  },
}
</script>
